import { createTypedReducerWithImmer } from "@insite/client-framework/Common/CreateTypedReducer";
import { SurFinancialTransactionsModel } from "@tSurya/Services/FinancialTransactions";
import { FinancialTransactionState } from "@tSurya/Store/Data/SurFinancialTransactionState";
import { Draft } from "immer";

const initialState: FinancialTransactionState = {
    isLoading: false,
    financialData: null,
    searchparameter: [],
    pagination: null,
};

const reducer = {
    "Custom/FinancialTransaction/BeginLoadFinancialTransaction": (draft: Draft<FinancialTransactionState>) => {
        draft.isLoading = true;
    },
    "Custom/FinancialTransaction/CompletedLoadFinancialTransactionStore": (
        draft: Draft<FinancialTransactionState>,
        action: { searchparameter: FinancialTransactionState },
    ) => {
        draft.searchparameter = action.searchparameter;
        draft.isLoading = true;
    },
    "Custom/FinancialTransaction/CompletedLoadFinancialTransaction": (
        draft: Draft<FinancialTransactionState>,
        action: { result: SurFinancialTransactionsModel },
    ) => {
        draft.financialData = action.result;
        draft.pagination = action.result.pagination;
        draft.isLoading = false;
    },
};

export default createTypedReducerWithImmer(initialState, reducer);
